<template>
  <div>

    <approval-remarks :row-data="actionData" :steps="actionData.steps" :legal-step="3" />

    <div v-if="legalApproved">
    <section v-if="isTowerCo()">
      <el-row>

        <el-form label-position="top" :inline="isBackhaul">

          <!-- TODO fill in contractors -->

          <el-col :span="7" v-if="false">
            <el-form-item> <!-- TODO fix step.state.contractorW to PTW -->
              <el-select v-model="step.state.contractorW"
              :disabled="disabled" />
            </el-form-item>
          </el-col>

          <el-col :span="7" :offset="1" v-if="false">
            <el-form-item>
              <el-select v-model="step.state.contractorTI"
              :disabled="disabled" />
            </el-form-item>
          </el-col>

          <el-col :span="7" :offset="1" v-if="false">
            <el-form-item>
              <el-select v-model="step.state.contractorMW"
              :disabled="disabled" />
            </el-form-item>
          </el-col>


        <section v-if="isBackhaul">
          <h4>Permit to Work</h4><br />
            <check-box v-model="step.state.approvalPTW" :disabled="disabled">{{step.state.approvalPTW ? 'Approved' : 'Pending / Rejected'}}</check-box>

            <date-input  v-if="step.state.approvalPTW" v-model="step.state.approvedPTW"
            :disabled="!step.state.approvalPTW || disabled" />

            <check-box  v-if="step.state.approvalPTW" v-model="step.state.depostiReturnedPTW" :disabled="!step.state.approvalPTW || disabled">Deposit Returned</check-box>

      </section>



      <section v-else>
        <el-row>

          <el-col :span="8">
            <h4>CME</h4>
            <check-box v-model="step.state.approvalCME" :disabled="disabled">{{step.state.approvalCME ? 'Approved' : 'Pending / Rejected'}}</check-box>
            <date-input v-if="step.state.approvalCME" v-model="step.state.approvedCME"
              :disabled="!step.state.approvalCME || disabled" />

            <check-box v-if="step.state.approvalCME" v-model="step.state.depostiReturnedCME" :disabled="!step.state.approvalCME || disabled">Deposit Returned</check-box>
          </el-col>

          <el-col :span="8">
            <h4>TI</h4>
              <check-box v-model="step.state.approvalTI" :disabled="disabled">{{step.state.approvalTI ? 'Approved' : 'Pending / Rejected'}}</check-box>

              <date-input v-if="step.state.approvalTI" v-model="step.state.approvedTI"
              :format="dateFormat"
              :disabled="!step.state.approvalTI || disabled" />

            <check-box v-if="step.state.approvalTI" v-model="step.state.depostiReturnedTI" :disabled="!step.state.approvalTI || disabled">Deposit Returned</check-box>

          </el-col>

          <el-col :span="8">
            <h4>MW</h4>
              <check-box v-model="step.state.approvalMW" :disabled="disabled">{{step.state.approvalMW ? 'Approved' : 'Pending / Rejected'}}</check-box>
              <date-input v-if="step.state.approvalMW" v-model="step.state.approvedMW"
              :disabled="!step.state.approvalMW || disabled" />

              <check-box v-if="step.state.approvalMW" v-model="step.state.depostiReturnedMW" :disabled="!step.state.approvalMW || disabled">Deposit Returned</check-box>
          </el-col>
        </el-row>
      </section>

    </el-form>

      <el-col :span="22" :class="disabled ? '' : 'bg-lighter'" :style="disabled ? '' : 'padding-left: 1em; padding-top: 1em; border-radius: 1em;'">

          <el-form :inline="true">

            <check-box v-model="step.state.depositRequired" :disabled="disabled">Overall Deposit Required</check-box>

            <el-form-item label="Paid" v-if="step.state.depositRequired">
              <el-switch active-text="Yes" inactive-text="No" v-model="step.state.paid" :disabled="disabled" />
            </el-form-item>

            <el-form-item label="Amount" v-if="step.state.depositRequired">
              <el-input type="number" v-model="step.state.deposit"
              :disabled="!step.state.paid || disabled">
              <template slot="prepend">{{currencyLabel}}</template>
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>

      </el-row>
  </section>

  <el-alert
  v-if="this.isActive(this.actionData)"
  type="info"
  title="Progress Remarks"
  show-icon />

  <html-input v-model="step.remarks" :disabled="disabled" />

  </div>

</div>

</template>



<script>

import {settings} from '@/components/Data'

import RequestMixins from '@/mixins/RequestMixins'

import FileDownload from '@/components/atoms/files/FileDownload'
import FileUpload from '@/components/atoms/files/FileUpload'

import ApprovalRemarks from '@/components/requests/workflow/ApprovalRemarks'


export default {

  mixins: [RequestMixins],

  components: {
    ApprovalRemarks,
    FileDownload,
    FileUpload
  },



  props: {

    rowData: {
      type: Object,
      required: true
    },

    rowIndex: {
      type: Number,
      required: true
    },

    stepData: {
      type: Object,
      default: null
    },

    readOnly: {
      type: Boolean,
      default: true
    },

    isClosed: {
      type: Boolean,
      default: false
    }

  },



  methods: {

    setStep (data) {
      if (data) {
        this.step = data
      }
    }

  },

  data () {

    return {
      disabled: this.isViewOnly() || this.readOnly,
      currencyLabel: settings.currency,
      dateFormat: settings.selectDateFormat,
      actionData: this.rowData,
      step: this.stepData,
      step3: this.rowData.state.step3,
      legalApproved: (this.rowData.status === 'Closed') ? true : this.rowData.state.step3.legalApproved
    }

  }, // data



  created () {
    if (this.step) {

      if (!this.readOnly || !this.isViewOnly()) {
        this.findStep(this.stepData.id, this.setStep)
      }

    }

  },



  beforeDestroy () {

    if (!this.readOnly && this.step) {

      this.$emit('updated', this.step)

      if (!this.readOnly || !this.isViewOnly()) {
        this.saveStep(this.step, null, this.actionData)
      }

    }

  }

}
</script>



// WEBPACK FOOTER //
// step4.vue?6d0c97cf